import { MODALS } from "@/constants/modals"
import { getEmbedUrl } from "@/utils/helpers"
import { useStore } from "@/zustand/store"
import { useTranslation } from "react-i18next"

export default function VideoModal() {
  const videoData = useStore(
    (state) => state.modalsStates[MODALS.lecture.video]
  )
  const url = videoData?.value

  const { t } = useTranslation()

  const embed = getEmbedUrl(url)

  if (!embed) {
    return (
      <p className="text-danger">{t("driveVideoPreview.errors.invalid")}</p>
    )
  }

  return (
    <div className="container-fluid ">
      {embed.type === "direct" ? (
        <video
          src={embed.url}
          controls
          autoPlay
          className="w-100 rounded"
          style={{ maxHeight: "80vh" }}
        />
      ) : (
        <div className="ratio ratio-16x9 mb-3">
          <iframe
            src={embed.url}
            title="Video Player"
            allow="autoplay"
            allowFullScreen
            style={{ border: 0, width: "100%", height: "100%" }}
          />
        </div>
      )}
    </div>
  )
}
